import type { Components } from '@/api/generated/api';
import type { ISupportMeasureReportAvailableContent } from '@/interfaces';

type TSupportMeasureEntry = Pick<
  Components.Schemas.SupportMeasureEntryDto,
  'competences' | 'completionNote' | 'materials' | 'protocol' | 'students'
>;

/**
 * The optional report sections that print anything for the given students (all current members when omitted). Like
 * the PDF, a student's apps are the measure's own and those of the protocol entries the student took part in.
 */
export const getSupportMeasureReportAvailableContent = (
  entry: TSupportMeasureEntry,
  studentIds: number[] | undefined,
): ISupportMeasureReportAvailableContent => {
  const reportStudentIds = new Set(studentIds ?? entry.students.map((student) => student.id));
  const hasProtocolMaterials = entry.protocol.some(
    (protocolEntry) =>
      protocolEntry.materials.length > 0 && protocolEntry.students.some((student) => reportStudentIds.has(student.id)),
  );

  return {
    competenceDevelopment: entry.competences.length > 0,
    completionNote: Boolean(entry.completionNote),
    materials: entry.materials.length > 0 || hasProtocolMaterials,
  };
};
